import { Controller } from "@hotwired/stimulus"

const STORAGE_KEY = "gimmo-theme"
const LIGHT_CLASS = "gimmo-light"

export default class extends Controller {
  static targets = ["icon"]

  connect() {
    this.applyStored()
    this.syncIcon()
  }

  toggle() {
    const next = document.body.classList.contains(LIGHT_CLASS) ? "dark" : "light"
    this.apply(next)
    try { localStorage.setItem(STORAGE_KEY, next) } catch (_) {}
    this.syncIcon()
  }

  applyStored() {
    let stored
    try { stored = localStorage.getItem(STORAGE_KEY) } catch (_) {}
    const initial = document.body.classList.contains(LIGHT_CLASS) ? "light" : "dark"
    this.apply(stored === "light" || stored === "dark" ? stored : initial)
  }

  apply(theme) {
    if (theme === "dark") {
      document.body.classList.remove(LIGHT_CLASS)
      document.documentElement.dataset.theme = "dark"
    } else {
      document.body.classList.add(LIGHT_CLASS)
      document.documentElement.dataset.theme = "light"
    }
  }

  syncIcon() {
    if (!this.hasIconTarget) return
    const isLight = document.body.classList.contains(LIGHT_CLASS)
    this.iconTargets.forEach(icon => {
      const showOn = icon.dataset.themeIcon
      icon.hidden = (showOn === "light") !== isLight
    })
  }
}
